import { SensorsIcon, LogoutIcon, DashboardIcon, ProjectIcon } from "../icons";

const navItemJson = [
  {
    id: 1,
    link: "/sensors/list",
    title: "sensor_list",
    icon: <SensorsIcon size={"1.2em"} />,
    ariaLabel: "sensor-list",
  },
  {
    id: 2,
    link: "/sensors/lookup",
    title: "sensor_lookup",
    icon: <SensorsIcon size={"1.2em"} />,
    ariaLabel: "sensor-lookup",
  },
  {
    id: 3,
    link: "/dashboard",
    title: "nav.dashboard",
    icon: <DashboardIcon size={"1.2em"} />,
    ariaLabel: "dashboard",
  },
  {
    id: 5,
    link: "/inventory",
    title: "nav.inventory",
    icon: <ProjectIcon size={"1.2em"} />,
    ariaLabel: "inventory",
  },
  {
    id: 4,
    link: "#logout",
    title: "logout",
    icon: <LogoutIcon size={"1.2em"} />,
    ariaLabel: "logout",
    isLogout: true,
  },
];

export default navItemJson;
